import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import './NewMain.css'
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Edit,
  Toolbar,
  ColumnChooser
} from "@syncfusion/ej2-react-grids";

import { daysGrid } from "../../data/dummy";
import { Header, Pagination } from "../../components";
import CreateAddIcon from "../../data/createAddIcon.png"
import { BASE_URL, deleteCall, get } from "../../Services/Calls";
import { setGridVisibility, getGridVisibility } from '../../Services/gridVisibilityHelper';

const PAGE_SIZE = 10

const Days = () => {

  const navigate = useNavigate();
  const toolbarOptions = ["Delete", 'Search', 'ColumnChooser'];
  const [daysData, setDaysData] = useState([])
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState(false)
  const editOptions = { allowEditing: false, allowAdding: true, allowDeleting: true };
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  const pageKey = 'day-page'; // unique key for each page
  const [isReady, setIsReady] = useState(false);
  const [columnSettings, setColumnSettings] = useState([]);
  useEffect(() => {
    const saved = getGridVisibility(pageKey);
    if (saved) setColumnSettings(saved);

    setIsReady(true);
  }, []);

  const finalColumns = daysGrid(setLoading).map((col) => {
    if (!col.field) return col; // Skip if no field (like checkbox/template)

    const match = columnSettings?.find((c) => c.field === col.field);
    return match
      ? { ...col, visible: match.visible }    // apply visibility state
      : { ...col };                           // fallback: visible by default
  });

  useEffect(() => {
    getDays(1, '');
  }, [])

  const getDays = async (page, search) => {
    setLoading(true);
    try {
      const countryId = localStorage.getItem("selectedCountry");
      const skip = (page - 1) * PAGE_SIZE;
      let url = `${BASE_URL}/days?order=DESC&take=${PAGE_SIZE}&skip=${skip}`;
      const trimmedSearch = search ? search.trim() : '';
      if (trimmedSearch && /^\d+$/.test(trimmedSearch)) {
        // The grid's ID column shows the friendly_id, which isn't part of
        // name/description, so a numeric search matches it exactly instead.
        url += `&friendly_id=${trimmedSearch}`;
      } else if (trimmedSearch) {
        url += `&q=${encodeURIComponent(trimmedSearch)}`;
      }
      if (countryId) url += `&country=${encodeURIComponent(countryId)}`;

      const response = await get(url);
      if (response) {
        const total = response.count ?? response.results?.length ?? 0;
        setDaysData(response.results ?? []);
        setTotalPages(Math.ceil(total / PAGE_SIZE) || 1);
        setTotalItems(total);
      }
    }
    catch (ex) {
      alert(ex)
    }
    finally {
      setLoading(false);
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    setSelectedRecords([]);
    getDays(page, searchTerm);
  };

  const actionBegin = (args) => {
    if (args.requestType === 'searching') {
      args.cancel = true;
      const term = args.searchString || '';
      setSearchTerm(term);
      setCurrentPage(1);
      setSelectedRecords([]);
      getDays(1, term);
    }
  };

  const toolbarClick = args => {
    switch (args.item.text) {
      case 'Delete':
        args.cancel = true;
        setDeleteConfirm(true)
        break
      default:
        break
    }
  }

  const handleDelete = async () => {
    setLoading(true);
    setDeleteConfirm(false)
    try {
      for (let i = 0; i < selectedRecords.length; i++) {
        await deleteCall(BASE_URL + '/days/' + selectedRecords[i].id)
      }
      const willEmptyPage = selectedRecords.length >= daysData.length;
      const targetPage = willEmptyPage && currentPage === totalPages && currentPage > 1 ? currentPage - 1 : currentPage;
      if (targetPage !== currentPage) setCurrentPage(targetPage);
      await getDays(targetPage, searchTerm);
    } catch (ex) {
      alert(ex)
    } finally {
      setLoading(false);
    }
  }

  const gridRef = useRef(null);
  const rowSelected = () => {
    if (gridRef.current) {
      const tempSelectedrecords = gridRef.current.getSelectedRecords()
      setSelectedRecords(tempSelectedrecords)
    }
  }

  const rowDeselected = args => {
    let tempSelectedRecords = [...selectedRecords]
    for (let i = 0; i < tempSelectedRecords.length; i++) {
      if (args.data.length > 1) {
        for (let j = 0; j < args.data.length; j++) {
          if (tempSelectedRecords[i].id == args.data[j].id) {
            tempSelectedRecords.splice(i, 1)
          }
        }
      } else {
        if (tempSelectedRecords[i].id == args.data.id) {
          tempSelectedRecords.splice(i, 1)
        }
      }
    }
    setSelectedRecords(tempSelectedRecords);
  }

  const onActionComplete = (args) => {
    if (args.requestType === 'columnstate') {
      const gridCols = gridRef.current?.getColumns() ?? [];
      const state = gridCols
        .filter((c) => !!c.field)
        .map((c) => ({
          field: c.field,
          visible: c.visible,
        }));
      setGridVisibility(pageKey, state);
    }
  };

  return (
    <div className="m-2 ml-10 mr-10 mt-5 p-2 p-5 bg-white rounded-3xl relative">
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-white h-12 w-12 animate-spin"></div>
        </div>
      )}
      <div className="flex justify-between items-center h-20">
        <Header category="" title="Days" />
        <div style={{ width: 200 }} className="w-100 border flex justify-end items-center mb-8 createBtn" onClick={() => { navigate('/createDay', { state: { from: 'create', data: {} } }) }}>
          <span>Add New Day</span>
          <img src={CreateAddIcon} style={{ width: 15, height: 15 }} alt="" />
        </div>
      </div>
      {isReady &&
        <GridComponent
          dataSource={daysData}
          editSettings={editOptions}
          toolbar={toolbarOptions}
          allowPaging={false}
          allowSorting
          allowFiltering={false}
          toolbarClick={toolbarClick}
          actionBegin={actionBegin}
          rowSelected={rowSelected}
          rowDeselected={rowDeselected}
          showColumnChooser={true}
          actionComplete={onActionComplete}
          ref={gridRef}
        >
          <ColumnsDirective>
            {finalColumns.map((item, index) => (
              <ColumnDirective key={index} {...item} />
            ))}
          </ColumnsDirective>
          <Inject services={[Edit, Toolbar, Page, ColumnChooser]} />
        </GridComponent>
      }
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={onPageChange}
      />
      {deleteConfirm && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              width: 400,
              height: 200,
              background: '#fff',
              borderRadius: 10,
              padding: '15px 20px'
            }}
          >
            <div
              style={{
                fontSize: 24,
                fontWeight: 'bold',
                color: '#000',
                marginBottom: 15
              }}
            >
              Delete Alert
            </div>
            <div style={{ fontSize: 18, color: '#000', marginBottom: 10 }}>
              {selectedRecords.length > 0 ? "Are you sure you want to delete selected rows." : "Please select at-least one row."}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 20
              }}
            >
              <div
                className='confirmOkBtn'
                onClick={() => {
                  setDeleteConfirm(false)
                }}
              >
                {selectedRecords.length > 0 ? "Cancle" : "Ok"}
              </div>
              {selectedRecords.length > 0 &&
                <div
                  className='confirmOkBtn'
                  onClick={() => {
                    handleDelete()
                  }}
                >
                  Yes
                </div>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Days;
